import { instanceOfErrorListResponse } from '@genial/services';
import { ErrorListResponse } from '@genial/services/src';
import { useEffect } from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { useToastCreator } from '../../../../../hooks/useToastCreator';
import { customerByAccountNumberQuery } from '../../../../../store/customer/selector';

export const useCustomer = (customerAccountNumber: number) => {
  const { showToastFromError } = useToastCreator('customer-detail-data-toast');

  const {
    data: customerData,
    error: customerDataIsError,
    loading: customerDataIsLoading,
  } = useRecoilQuery(
    customerByAccountNumberQuery({
      accountNumber: customerAccountNumber,
      currentScreen: 'CustomerDetail',
    })
  );

  useEffect(() => {
    if (customerDataIsError) {
      if (instanceOfErrorListResponse(customerDataIsError)) {
        (customerDataIsError as unknown as ErrorListResponse).errors?.forEach((errorItem) =>
          showToastFromError(errorItem)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerDataIsError]);

  return { customerData, customerDataIsLoading, customerDataIsError };
};
